import classNames from 'classnames';
import Link from 'next/link';
import { FC, useCallback, useEffect, useState } from 'react';

import { Locale, replaceOrAddLocale, useLocale } from '../../helpers/LangHelper';
import { useWindowSize } from '../../hook/useWindowSize';
import BusinessButton from '../business-button/business-button';
import Icon, { IconType } from '../icons';
import { BusinessHubTopNavigationMenuItem } from './business-hub-top-navigation-menu-item';
import styles from './business-hub-top-navigation.module.scss';
import { BuilderContent } from '@builder.io/react';

interface Props {
    signupLink?: string;
    page: any;
}

export const BusinessHubTopNavigation: FC<Props> = (props) => {
    const { signupLink, page } = props;

    const [isMobileMenuActive, setIsMobileMenuActive] = useState(false);
    const [needCloseMobileMenu, setNeedCloseMobileMenu] = useState(false);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const { width = 0 } = useWindowSize();
    const [scrollY, setScrollY] = useState<number>(0);
    const { locale } = useLocale();

    useEffect(() => {
        if (width < 1200) {
            setIsMobile(true);
        } else {
            setIsMobile(false);
        }
    }, [width]);

    useEffect(() => {
        if (isMobile) {
            if (needCloseMobileMenu) {
                setNeedCloseMobileMenu(false);
                setIsMobileMenuActive(false);
            }
        } else {
            setNeedCloseMobileMenu(true);
            if (isMobileMenuActive) {
                setIsMobileMenuActive(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile]);

    useEffect(() => {
        const body = document.body;
        if (!body) {
            return;
        }

        if (isMobileMenuActive) {
            body.classList.add('lock-scroll');
        } else {
            body.classList.remove('lock-scroll');
        }
    }, [isMobileMenuActive]);

    useEffect(() => {
        document.addEventListener('scroll', onScroll);
        onScroll();

        return () => {
            document.removeEventListener('scroll', onScroll);
        };
    }, []);

    const onScroll = useCallback(() => {
        setScrollY(window.scrollY);
    }, []);

    const handleClickToggleMenu = () => {
        setIsMobileMenuActive((oldState) => !oldState);
    };

    return (
        <div className={styles.container} style={{ '--bh-scroll-y': `${scrollY}px` } as any}>
            <div className={styles.box}>
                <Link href={replaceOrAddLocale('/business', locale)} className={styles.logo} aria-label="Home">
                    {isMobile ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
                            <path
                                d="M28.9676 6.63199L24.6358 4.11382L20.2413 1.5575C17.3367 -0.133998 13.706 1.98991 13.706 5.39834V5.97065C13.706 6.2886 13.8688 6.58112 14.1442 6.73373L16.1849 7.91651C16.7483 8.24718 17.4494 7.82748 17.4494 7.16615V5.80532C17.4494 5.13126 18.1631 4.71157 18.739 5.04224L22.7453 7.38235L26.7391 9.70975C27.315 10.0404 27.315 10.8925 26.7391 11.2232L22.7453 13.5506L18.739 15.8907C18.1631 16.2214 17.4494 15.8017 17.4494 15.1276V14.4536C17.4494 11.0451 13.8187 8.90851 10.9141 10.6127L6.51966 13.1691L2.18783 15.6872C-0.729276 17.3914 -0.729276 21.6774 2.18783 23.3816L6.51966 25.8998L10.9141 28.4561C13.8187 30.1476 17.4494 28.0237 17.4494 24.6153V24.043C17.4494 23.725 17.2867 23.4325 17.0112 23.2799L14.9705 22.0971C14.4071 21.7664 13.706 22.1861 13.706 22.8475V24.2083C13.706 24.8824 12.9924 25.302 12.4165 24.9714L8.41016 22.6313L4.41635 20.3039C3.84044 19.9732 3.84044 19.1211 4.41635 18.7904L8.41016 16.463L12.4165 14.1229C12.9924 13.7922 13.706 14.2119 13.706 14.886V15.56C13.706 18.9685 17.3367 21.1051 20.2413 19.4009L24.6358 16.8446L28.9676 14.3264C31.8847 12.6095 31.8847 8.3362 28.9676 6.63199Z"
                                fill="black"
                            />
                        </svg>
                    ) : locale === Locale.GreatBritain ? (
                        <Icon type={IconType.LogoClearpay} />
                    ) : (
                        <Icon type={IconType.AfterPay} />
                    )}
                </Link>

                <div className={classNames(styles.menuBox)}>
                    <div className={classNames(styles.menuItems, { [styles.active]: isMobileMenuActive })}>
                        <BusinessHubTopNavigationMenuItem />
                        {/* {isMobile ? (
                            <div className={styles.menuItemsBg}>
                                <svg viewBox="0 0 2302 2074" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="Vector">
                                        <mask id="path-1-inside-1_57_20" fill="white">
                                            <path d="M2140.35 418.559L1820.28 232.605L1495.58 43.8324C1280.97 -81.0766 1012.7 75.7639 1012.7 327.46V369.723C1012.7 393.202 1024.73 414.803 1045.08 426.073L1195.87 513.415C1237.49 537.834 1289.3 506.841 1289.3 458.005V357.514C1289.3 307.738 1342.02 276.745 1384.58 301.164L1680.59 473.97L1975.69 645.838C2018.24 670.256 2018.24 733.18 1975.69 757.598L1680.59 929.466L1384.58 1102.27C1342.02 1126.69 1289.3 1095.7 1289.3 1045.92V996.146C1289.3 744.45 1021.03 586.67 806.418 712.518L481.722 901.291L161.653 1087.25C-53.8845 1213.09 -53.8845 1529.59 161.653 1655.44L481.722 1841.4L806.418 2030.17C1021.03 2155.08 1289.3 1998.24 1289.3 1746.54V1704.28C1289.3 1680.8 1277.27 1659.2 1256.92 1647.93L1106.13 1560.59C1064.51 1536.17 1012.7 1567.16 1012.7 1616V1716.49C1012.7 1766.26 959.977 1797.25 917.424 1772.84L621.407 1600.03L326.314 1428.16C283.761 1403.74 283.761 1340.82 326.314 1316.4L621.407 1144.53L917.424 971.728C959.977 947.31 1012.7 978.302 1012.7 1028.08V1077.85C1012.7 1329.55 1280.97 1487.33 1495.58 1361.48L1820.28 1172.71L2140.35 986.755C2355.88 859.967 2355.88 544.408 2140.35 418.559Z"></path>
                                        </mask>
                                        <path
                                            d="M2140.35 418.559L1820.28 232.605L1495.58 43.8324C1280.97 -81.0766 1012.7 75.7639 1012.7 327.46V369.723C1012.7 393.202 1024.73 414.803 1045.08 426.073L1195.87 513.415C1237.49 537.834 1289.3 506.841 1289.3 458.005V357.514C1289.3 307.738 1342.02 276.745 1384.58 301.164L1680.59 473.97L1975.69 645.838C2018.24 670.256 2018.24 733.18 1975.69 757.598L1680.59 929.466L1384.58 1102.27C1342.02 1126.69 1289.3 1095.7 1289.3 1045.92V996.146C1289.3 744.45 1021.03 586.67 806.418 712.518L481.722 901.291L161.653 1087.25C-53.8845 1213.09 -53.8845 1529.59 161.653 1655.44L481.722 1841.4L806.418 2030.17C1021.03 2155.08 1289.3 1998.24 1289.3 1746.54V1704.28C1289.3 1680.8 1277.27 1659.2 1256.92 1647.93L1106.13 1560.59C1064.51 1536.17 1012.7 1567.16 1012.7 1616V1716.49C1012.7 1766.26 959.977 1797.25 917.424 1772.84L621.407 1600.03L326.314 1428.16C283.761 1403.74 283.761 1340.82 326.314 1316.4L621.407 1144.53L917.424 971.728C959.977 947.31 1012.7 978.302 1012.7 1028.08V1077.85C1012.7 1329.55 1280.97 1487.33 1495.58 1361.48L1820.28 1172.71L2140.35 986.755C2355.88 859.967 2355.88 544.408 2140.35 418.559Z"
                                            stroke="#B2FCE4"
                                            strokeWidth="4"
                                            mask="url(#path-1-inside-1_57_20)"
                                        ></path>
                                    </g>
                                </svg>
                            </div>
                        ) : null} */}
                    </div>
                    {[Locale.Australia, Locale.NewZealand].includes(locale) ? (
                        <BusinessButton
                            link={locale === Locale.NewZealand ? 'https://hub.afterpay.com/nz' : 'https://hub.afterpay.com/au'}
                            target="_blank"
                            className={classNames(styles.signup, styles.hoverBondiMint)}
                            buttonText={isMobile ? 'Login' : 'Business login'}
                            autoMargin={false}
                            color="black"
                        />
                    ) : null}
                    <BusinessButton link={signupLink} target="_blank" className={styles.signup} buttonText={isMobile ? 'Sign-up' : 'Business sign-up'} autoMargin={false} />
                </div>

                <div className={classNames(styles.hamburger, { [styles.active]: isMobileMenuActive })} onClick={() => handleClickToggleMenu()}>
                    <div className={styles.iconMenu}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </div>
        </div>
    );
};
